import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { CANCEL_BOOKING_SCHEDULE_MESSAGE, Rating, ratings, REATTEMPT_PAY_REPAY_SCHEDULE_MESSAGE, ROUTES, USER_ROLES } from "@shared/constant/shared.constant";
import { LoaderService } from "./services/loader.service";
import { ToastService } from "./services/toast.service";
import { Utility } from "./services/utility.abstract";
import { DriverService } from '@shared/components/driver/services/driver.service';
import { Router } from "@angular/router";
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { PaymentStatusForMessage, roleRoutes } from "@core/models/api-response.model";
import { Calendar } from "primeng/calendar";
import * as XLSX from 'xlsx';
import { ConfigService } from "@core/services/config.service";
export class CommonFunctions {

  // Function to prevent spaces from being entered in an input
  static preventSpaces(event: KeyboardEvent): void {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }

  static preventFirstSpaces(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;

    // Check if the first character is a space
    if (input.selectionStart === 0 && event.key === ' ') {
      event.preventDefault();
    }
  }

  static onlyNumberInput(event: KeyboardEvent): void {
    const isNumber = /^[0-9]$/.test(event.key);
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'a', 'v'];
    const isCtrlA = event.key === 'a' && (event.ctrlKey || event.metaKey);
    const isCtrlV = event.key === 'v' && (event.ctrlKey || event.metaKey);
    if (!isNumber && !allowedKeys.includes(event.key) && !isCtrlA && !isCtrlV) {
      event.preventDefault();
    }
  }

  static groupVehicleTypes(types: any[]): any[] {
    const grouped = {};
    types.forEach((type) => {
      const categoryName = type.categoryName;

      if (!grouped[categoryName]) {
        grouped[categoryName] = {
          label: categoryName,
          value: categoryName,
          items: [],
        };
      }

      grouped[categoryName].items.push({
        name: type.name,
        id: type.id,
        vehicleTypeImagePath: type.vehicleTypeImagePath,
      });
    });

    return Object.values(grouped);
  }

  static groupVehicleTypesBookings(types: any[]): any[] {
    const grouped = {};
    types.forEach((type) => {
      const categoryName = type.categoryName;

      if (!grouped[categoryName]) {
        grouped[categoryName] = {
          label: categoryName,
          value: categoryName,
          items: [],
        };
      }

      grouped[categoryName].items.push({
        label: type.name,
        value: type.id,
        imagePath: type.vehicleTypeImagePath,
      });
    });

    return Object.values(grouped);
  }

  static findSelectedTruckTypeGroup(groupedVehicles: any[], selectedValue: string) {
    const result = groupedVehicles
      .map(group => ({
        label: group.label,
        value: group.value,
        selectedItem: group.items.find(item => item.value === selectedValue)
      }))
      .find(group => group.selectedItem !== undefined) || null;

    return result;
  }

  static findSelectedTruckTypemodal(groupedVehicles: any[], selectedValue: string) {
    const result = groupedVehicles
      .map(group => ({
        name: group.label,
        id: group.value,
        selectedItem: group.items.find(item => item.id === selectedValue)
      }))
      .find(group => group.selectedItem !== undefined) || null;

    return result;
  }

  // Static method to get the tooltip message based on truck type label
  static tooltipMessageByCategory(selectedTruckLabel: string, tooltipFullLengthMessage: string, tooltipHalfLengthMessage: string): string {
    return selectedTruckLabel === 'Full-Length Spot (12x75 ft)' ? tooltipFullLengthMessage : tooltipHalfLengthMessage;
  }

  static routeToBookingDetail(role: string): string {
    if (role === USER_ROLES.SUPER_ADMIN) {
      return ROUTES.SUPER_ADMIN;
    } else if (role === USER_ROLES.PARKING_MANAGER || role === USER_ROLES.PARKING_OWNER) {
      return ROUTES.MANAGER;
    } else if(role === USER_ROLES.GROUP_USER) {
      return ROUTES.GROUP_OPERATOR;
    }else {
      return ROUTES.DRIVER;
    }
  }

  static onlyAcceptNumber(event: KeyboardEvent): void {
    const isAllowed =
      /^[0-9]$/.test(event.key) ||
      ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(event.key);

    if (!isAllowed) {
      event.preventDefault();
    }
  }

  static isAdminOrOwnerRole(role: string): boolean {
    const superAdminRoles = [
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.PARKING_MANAGER,
      USER_ROLES.PARKING_OWNER,
    ];
    return superAdminRoles.includes(role);
  }

  static onKeyDown(event: KeyboardEvent): void {
    if (event.key >= '0' && event.key <= '9') {
      event.preventDefault();
    }
  }

  static formatToDateTimeString(date: Date, datePipe: DatePipe): string {
    return datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
  }
static localDateInDashboard(date: Date, datePipe: DatePipe): string {
  const hours = String(new Date().getHours()).padStart(2, '0');
  const paramDate = datePipe.transform(date, 'yyyy-MM-dd');
  return `${paramDate} ${hours}:00:00`;
}


  static formatDatePlaceholder(date: string, datePipe: DatePipe): string {
    return datePipe.transform(date, 'MMM dd, yyyy');
  }
  static formatDate(date: string,datePipe: DatePipe): string {
    return datePipe.transform(date, 'yyyy-MM-dd');
  }
  static repayFunc(bookingId: string, loaderService: LoaderService, driverService: DriverService,toastService: ToastService){
    loaderService.showLoader();
    const request = {
      bookingId: bookingId,
      timeZone: Utility.getLocalTimeZone(),
    };

    driverService.RePaymentSession(request).subscribe({
      next: (response: any) => {
        loaderService.hideLoader();
        if (response?.data) {
          window.open(response.data.url, '_blank');
        }
      },
      error: (error: HttpErrorResponse) => {
        loaderService.hideLoader();
        toastService.showToastMessage('error', 'Error', error.error.message);
      },
    });
  }

  static payUrlFunc(bookingId: string,invoiceId: string, loaderService: LoaderService, driverService: DriverService,toastService: ToastService){
    loaderService.showLoader();
    const request = {
      bookingId: bookingId,
      invoiceId: invoiceId,
    };

    driverService.paymentUrlMethod(request).subscribe({
      next: (response: any) => {
        loaderService.hideLoader();
        if (response?.data) {
          window.open(response.url, '_blank');
        }
      },
      error: (error: HttpErrorResponse) => {
        loaderService.hideLoader();
        toastService.showToastMessage('error', 'Error', error.error.message);
      },
    });
  }

 static navigateToCRM(
    roleRoute: string,
    id: any,
    router: Router,
    driverService: DriverService,
    routeSegment: string,
    paramName: string = 'id',
    tab: string = '0'
  ): void {
    const currentUrl = router.url;
    driverService.setPreviousUrl(currentUrl);

    router.navigate([`${roleRoute}/${routeSegment}`], {
      queryParams: {
        [paramName]: id,
        tab: tab,
      },
    });
  }

  static noLeadingSpacesValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      return typeof value === 'string' && value.startsWith(' ')
        ? { leadingSpace: true }
        : null;
    };
  }

  static openCalendar(calendar: Calendar) {
    if (calendar) {
      calendar.showOverlay();
      calendar.inputfieldViewChild.nativeElement.dispatchEvent(new Event('focus'));
      calendar.inputfieldViewChild.nativeElement.dispatchEvent(new Event('click'));
    }
  }

  static scrollTopRow(tblName: string): void {
    const rows = document.querySelectorAll(`#tbl-${tblName} tr`);
    if (rows?.length > 1) {
      rows[1].scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };

  static scrollToTop(selector?: string): void {
    if (selector) {
      const element = document.querySelector(selector);
      element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  static exportToExcel(
    data: any[],
    headers: { key: string; header: string; formatter?: (value: any, item?: any) => any }[],
    fileName: string
  ): void {

    const formattedData = data?.length ? data.map((item) =>
      headers.reduce((acc, { key, header, formatter }) => {
        const value = key ? this.getValueByKey(item, key) : null;
        acc[header] = formatter ? formatter(value, item) : value;
        return acc;
      }, {} as Record<string, any>)
    )
      : [Object.fromEntries(headers.map(({ header }) => [header, null]))];


    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };

    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}-${currentDate.getFullYear()}`;
    XLSX.writeFile(workbook, `${fileName}${formattedDate}.xlsx`);
  }

  private static getValueByKey(item: any, key: string): any {
    return key.split('.').reduce((acc, curr) => acc?.[curr] ?? null, item);
  }
  static navigateToMessageRoute(bookingId: string, role: string, router: Router) {
    const route = roleRoutes[role];
    if (route) {
      router.navigate([route], {
        queryParams: {
          id: bookingId,
        },
      });
    }
  }

  static openGatePass(tabName: string, bookingDetails): string {
    const now = new Date();
    const currentDateISO = now.toISOString();
    const startDate = new Date(new Date(bookingDetails?.startDate).getTime() - 4 * 60 * 60 * 1000).toISOString();
    const endDate = new Date(bookingDetails?.endDate).toISOString();
    const isDateInRange = currentDateISO >= startDate && currentDateISO <= endDate;
    const bookingStartTime = (new Date(bookingDetails?.startDate)).getTime();
    const fourHoursBefore = bookingStartTime - 4 * 60 * 60 * 1000;
    const tenDaysAfter = bookingStartTime + 10 * 24 * 60 * 60 * 1000;
    const nowTime = now.getTime();
    const isStartDateInRange = nowTime >= fourHoursBefore && nowTime <= tenDaysAfter;
    const isCompletedOrSpecificStatuses = [
      PaymentStatusForMessage.Completed,
      PaymentStatusForMessage.PartialCancel,
      PaymentStatusForMessage.Processing,
      PaymentStatusForMessage.RecurringPendingPayment,
      PaymentStatusForMessage.DisputeCreated,
      PaymentStatusForMessage.DisputeUpdated,
      PaymentStatusForMessage.DisputeLoss,
      PaymentStatusForMessage.DisputeExpired,
    ].includes(bookingDetails?.paymentStatus);

    if (isCompletedOrSpecificStatuses && tabName === 'current') {
        return isDateInRange ? 'hyperlink' : 'greyout';
    }
    if (tabName === 'pending') {
        return isStartDateInRange ? 'hyperlink' : 'greyout';
    }
    else  if(tabName === 'current' && (isCompletedOrSpecificStatuses && bookingDetails?.status === 'Completed')) {
      return 'accesscode'
    }
    else if(tabName === 'current' && (bookingDetails?.paymentStatus === PaymentStatusForMessage.PartialCancel && bookingDetails?.status === 'Partially Cancelled')) {
      return 'accesscode'
    }
    else if(tabName === 'past' && (bookingDetails?.paymentStatus === PaymentStatusForMessage.PartialCancel && bookingDetails?.status === 'Partially Cancelled')) {
      return 'accesscode'

    }
    else if(tabName === 'pending' && (bookingDetails?.paymentStatus === PaymentStatusForMessage.PartialCancel && bookingDetails?.status === 'Partially Cancelled')) {
      return 'accesscode'

    }
    else if ((isCompletedOrSpecificStatuses) && tabName === 'current') {
      return 'hyperlink';
    }else if (tabName === 'past' && (bookingDetails?.paymentStatus === PaymentStatusForMessage.Cancelled || bookingDetails?.paymentStatus === PaymentStatusForMessage.Failure)) {
      return 'dash';
    }
    else if (tabName === 'past' && isCompletedOrSpecificStatuses &&  (bookingDetails?.status === 'Cancelled')) {
      return  'dash' ;
    }
    else if(tabName === 'past' && (isCompletedOrSpecificStatuses && bookingDetails?.status === 'Completed')) {
      return 'greyout'
    }
    else if (tabName === 'pending' && (bookingDetails?.paymentStatus === PaymentStatusForMessage.Failure )) {
      return 'dash';
    }
    else if (tabName === 'pending' && (isCompletedOrSpecificStatuses && bookingDetails?.status === 'In Progress')) {
      return 'greyout';
    }
    else if(tabName === 'pending' && (isCompletedOrSpecificStatuses  && bookingDetails?.status === 'Completed')) {
      return 'greyout'
    }
    else {
      return 'dash';
    }
  }

  static assignParkerAction(_bookingData) {
    let parkerAction: boolean;
    const currentDate = new Date();
    const currentTimeInSeconds = Math.floor(currentDate.getTime() / 1000);
    switch (_bookingData.status) {
      case 'Completed':
      case 'Cancelled':
        parkerAction = false;
        break;
      case 'Partially Cancelled':
        if(currentTimeInSeconds <= _bookingData.departureTimeStamp) {
          parkerAction = true;
        }else {
          parkerAction = false;
        }
        break;
      default:
        parkerAction = true;
        break;
    }
    return parkerAction;
  }

  static bookingDateIsBetweenStartEndDate(_bookingData) {
    return _bookingData.isLastBillingCycle;
  }

  static getLastNameValidators(context: 'driver' | 'groupOperator' | 'parkingAdmin' | 'parkingManager', configService: ConfigService
  ): { validators: ValidatorFn[]; required: boolean } {
    const roleRequirements: Record<string, boolean> = {
      driver: configService.get('isDriverLastNameRequired'),
      groupOperator: configService.get('isGroupOperatorLastNameRequired'),
      parkingAdmin: configService.get('isParkingAdminLastNameRequired'),
      parkingManager: configService.get('isManagerLastNameRequired'),
    };

    const required = !!roleRequirements[context];
    const validators: ValidatorFn[] = required ? [Validators.required] : [];

    return { validators, required };
  }

  static convertTimeBetweenZones(
    toTimeZone: string,
    date: Date | string
  ): Date {
    const fromTimeZone = Utility.getLocalTimeZone();
    const utcDate = new Date(date instanceof Date ? date.toISOString() : date);
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: toTimeZone || fromTimeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });

    const parts = formatter.formatToParts(utcDate);
    const dateParts: any = {};
    parts.forEach(({ type, value }) => {
      if (type !== 'literal') dateParts[type] = value;
    });

    const finalDateStr = `${dateParts.year}-${dateParts.month}-${dateParts.day} ${dateParts.hour}:${dateParts.minute} ${dateParts.dayPeriod}`;

    return this.parseCustomDateTime(finalDateStr);
  }

  static parseCustomDateTime(dateTimeStr: string): Date {
    const [datePart, timePart, meridian] = dateTimeStr.split(/[\s:]+/);
    let hour = parseInt(timePart, 10);
    const minute = parseInt(dateTimeStr.split(/[\s:]+/)[2], 10);
    const ampm = dateTimeStr.split(' ')[2];

    if (ampm === 'PM' && hour < 12) hour += 12;
    if (ampm === 'AM' && hour === 12) hour = 0;

    const isoString = `${datePart}T${hour.toString().padStart(2, '0')}:${minute
      .toString()
      .padStart(2, '0')}:00`;

    return new Date(isoString);
  }

  static getTimeZoneAbbreviation(timeZone: string): string {
    const date = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'short',
    });

    const parts = formatter.formatToParts(date);
    const zonePart = parts.find(part => part.type === 'timeZoneName');
    return zonePart?.value || '';

  }

  static getScheduleStatus(bookingScheduledAction: string, bookingScheduledDate: string): string | null {
  if (bookingScheduledAction && bookingScheduledDate) {
    if (bookingScheduledAction === 'Payment Reattempt') {
      return `${REATTEMPT_PAY_REPAY_SCHEDULE_MESSAGE} ${bookingScheduledDate}`;
    } else {
      return `${CANCEL_BOOKING_SCHEDULE_MESSAGE} ${bookingScheduledDate}`;
    }
  }
  return null;
}
  static formatDateTime(date: Date, hour: number): string {
    const d = this.combineDateHours(date, hour);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    const seconds = d.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  static combineDateHours(date, hours): Date {
    let newHour = parseInt(hours, 10);
    let updatedDate = new Date(date);
    updatedDate.setHours(newHour);
    updatedDate.setMinutes(0);
    updatedDate.setSeconds(0);
    updatedDate.setMilliseconds(0);
    return updatedDate;
  }

  static formatDateToStandard(input: string, dateTime, inputFormat: string = 'LLL dd, yyyy - hh:mm a', outputFormat: string = 'yyyy-MM-dd HH:mm:ss'): string {
      const format = dateTime.fromFormat(input, inputFormat, { zone: 'local' });
      if (!format.isValid) {
        return '';
      }
      return format.toFormat(outputFormat);
    }

   static gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  static handleKeyDown(event: KeyboardEvent, action: (val?: any) => void, value?: any): void {
    const key = event.key;
    if (key === 'Enter' || key === ' ') {
      event.preventDefault();
      action(value);
    }
  }
  static handleKeyDownMultiparam(event: KeyboardEvent, action: (val?: any, val2?: any, val3?: any, val4?: any) => void, value?: any, value2?: any, value3?: any, value4?: any): void {
    const key = event.key;
    if (key === 'Enter' || key === ' ') {
      event.preventDefault();
      action(value, value2, value3, value4);
    }
  }
   static openTruckCheckOutUrl(event: MouseEvent, url: string) {
    event.preventDefault();
    window.open(`${url}`, '_blank');
  }

 static getRatingIndex(parkingExperinceRating: number): number {
  return 5 - parkingExperinceRating;
}

 static getSelectedRating(parkingExperinceRating: number): Rating | null {
  const index = CommonFunctions.getRatingIndex(parkingExperinceRating);
  return ratings[index] || null;
}

  static parseIsoWithoutTimezone(value: string | null | undefined): Date | string {
    if (!value) return '-';
    const [datePart, timePart] = value.split("T");
    const [year, month, day] = datePart.split("-").map(Number);

    const timeOnly = timePart.split(/[+-]/)[0]; // "01:00:00"
    const [hour, minute, second] = timeOnly.split(":").map(Number);

    return new Date(year, month - 1, day, hour, minute, second);
  }

  static htmlEncode(content: string): string {
    const element = document.createElement('div');
    element.innerText = content;
    return element.innerHTML;
  }

  static chartOptionsForGraph(isSingleMonth, externalTooltipHandler, myCustomPipe, paddingChart):{} {
    const chartOptions ={
          interaction: {
            mode: 'index',
            intersect: false,
          },
          aspectRatio: 1.3,
          maintainAspectRatio: false,
          scales: {
            x: {
              grid: {
                display: true,
              },
              offset: isSingleMonth,
              ticks: {
                autoSkip: false,
              },
            },
            y: {
              type: 'linear',
              display: true,
              min: 0,
              position: 'left',
              grid: {
                display: true,
              },
              ticks: {
                callback: function (value) {
                  return Number(value) >= 1000
                    ? '$' + myCustomPipe.transform(Number(value) / 1000) + 'k'
                    : '$' + value;
                },
              },
            },
          },
          plugins: {
            tooltip: {
              enabled: false,
              intersect: true,
              position: 'nearest',
              external: externalTooltipHandler,
            },
            legend: {
              position: 'bottom',
              labels: {
                boxHeight: 6,
                boxWidth: 6,
                padding: paddingChart, // Adds space between the legend items themselves
              },
            },
          },
          hover: {
            mode: 'nearest',
            intersect: false,
          },
          layout: {
            padding: {
              left: 20,
              right: 20,
              top: 10,
            },
          },
          elements: {
            line: {
              tension: 0.4,
            },
          },
        };
    return chartOptions;
  }

  static getOrCreateTooltip(){
    const getOrCreateTooltip = (chart) => {
      let tooltipEl = chart.canvas.parentNode.querySelector('div');

      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.style.background = 'white';
        tooltipEl.style.borderRadius = '5px';
        tooltipEl.style.color = 'black';
        tooltipEl.style.opacity = 1;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(0px, -100%)';
        tooltipEl.style.transition = 'all .1s ease';
        tooltipEl.style.box = 'all .1s ease';
        tooltipEl.style.width = 'auto';
        tooltipEl.style.boxShadow = '0 0 10px rgba(0, 0, 0, 0.3)';
        tooltipEl.style.zIndex = '1';

        const table = document.createElement('table');
        table.style.margin = '0px';
        table.style.width = '140px';
        table.className = 'custom-occupancy custom-registered-analysis';
        table.style.tableLayout = 'auto';
        tooltipEl.appendChild(table);

        chart.canvas.parentNode.appendChild(tooltipEl);
      }

      return tooltipEl;
    };
    return getOrCreateTooltip;
  }

  static formatCurrentTime(): Date {
    const now = new Date();
    now.setHours(now.getHours() + 1);
    now.setMinutes(0);
    now.setSeconds(0);
    now.setMilliseconds(0);
    return now;
  }
  
  static numbersOnlyValidator(event: any) {
    const pattern = /^[0-9\-]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9\-]/g, "");
    }
  }

  static getDaysForMonths(months: number): number {
    const today = new Date();
    const pastDate = new Date(today);
    pastDate.setMonth(today.getMonth() - months); // Move back by 'months'
    const differenceInTime = today.getTime() - pastDate.getTime();
    return Math.ceil(differenceInTime / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
  }
}
